// extracted by mini-css-extract-plugin
export default {"check_box_wrap":"CheckBox_check_box_wrap__mpeY0","check_box":"CheckBox_check_box__rvQRU"};